import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "tab-item"
};
export default {
  __name: 'index',
  props: {
    toolContent: {
      type: String,
      default: '面板'
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_t_icon = _resolveComponent("t-icon");
      var _component_t_tooltip = _resolveComponent("t-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", null, [_renderSlot(_ctx.$slots, "default")]), _createVNode(_component_t_tooltip, {
        theme: "default",
        showArrow: false,
        placement: __props.placement,
        content: __props.toolContent
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_t_icon, {
            name: "help-circle",
            class: "help-circle"
          })];
        }),
        _: 1
      }, 8, ["placement", "content"])]);
    };
  }
};